import React, { createContext, useState } from "react";
import _ from "lodash";
import { evenRound } from "util/NumberUtils";

export const PaymentCartContext = createContext();


const PaymentCartContextProvider = (props) => {
    const [paymentCartItems, setPaymentCartItems] = useState([]);

    //the amount is for display only. It will be varified at the server
    //type: bill or donation
    //id for donation will always be fixed so that each session if there are donations in cart
    //the wil populate the donation screen. Once paid these wil clear
    //ID for donation will be DONATION
    // structure of payment cart item is
    const addToCart = async (id, commitmentType, itemDetail, account, accountType, qty = 1) => {
        // Check if item with same id already exists
        const existingItem = paymentCartItems.find((item) => item.id === id);
        if (existingItem) {
            //the quantity logic is not supported. Quantity item level while amount and description 
                //is at lineItemLevel. To support quanity move quantity to lineItemLevel 
            //existingItem.qty = parseInt(existingItem.qty) + 1;
            //existingItem.itemDetail.amountDue = parseFloat(existingItem.itemDetail.amountDue) + parseFloat(itemDetail.amountDue);
            setPaymentCartItems([...paymentCartItems]);
            return;
        }
        //until full cart functionality is implemented in the ui. always override the cart with new item being added
        setPaymentCartItems([...paymentCartItems, { id, commitmentType, itemDetail, account, accountType, qty }])
        return paymentCartItems;
    }

    const addMultipleToCart = async (paymentCartItemsArray) => {
        //until full cart functionality is implemented in the ui. always override the cart with new item being added
        let pmtCrtItemsClone = _.cloneDeep(paymentCartItems);
        paymentCartItemsArray.forEach(cartItem => {
            const existingItem = pmtCrtItemsClone.find(item => item.id === cartItem.id);
            if (existingItem) {
                //the quantity logic is not supported. Quantity item level while amount and description 
                //is at lineItemLevel. To support quanity move quantity to lineItemLevel 
                // If the item already exists, update quantity and amount
                //existingItem.qty = parseInt(existingItem.qty) + 1;
                //existingItem.itemDetail.amountDue = parseFloat(existingItem.itemDetail.amountDue) + parseFloat(cartItem.itemDetail.amountDue);
            } else {
                // If the item doesn't exist, add it to the combined array
                pmtCrtItemsClone.push({ ...cartItem });
            }
        });
        setPaymentCartItems([...pmtCrtItemsClone])
        return paymentCartItems;
    }
    const removeFromCart = async (itemId) => {
        const updatedPaymentCartItems = paymentCartItems.filter((item) => item.id !== itemId);
        setPaymentCartItems(updatedPaymentCartItems);
    }
    const emptyCart = async () => {
        setPaymentCartItems([]);
    }

    const calculateTotalAmount = (salesTaxRate, cartItems) => {
        let pmtCartItems = cartItems || paymentCartItems;
        let totalPaymentAmount = 0.00;
        for (let pci of pmtCartItems) {
            for (let li of pci.itemDetail.lineItems) {
                let salesTax = 0.00;
                if (li.taxable) {
                    salesTax = parseFloat(li.lineItemAmount) * parseFloat(li.quantity) * parseFloat(salesTaxRate);
                }
                totalPaymentAmount = evenRound(parseFloat(totalPaymentAmount) + parseFloat(li.lineItemAmount * li.quantity) + parseFloat(salesTax), 2);

            }
        }
        return totalPaymentAmount;
    }

    return (
        <>
            {<PaymentCartContext.Provider value={{ addToCart, addMultipleToCart, removeFromCart, emptyCart, calculateTotalAmount, paymentCartItems }}>
                {props.children}
            </PaymentCartContext.Provider>}
        </>);
}

export default PaymentCartContextProvider